import _ from "lodash";
import { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../hooks/hooks";
import { selectVenturesListItems } from "../../redux/ventures/selector";
import { ventures } from "../../redux/ventures/action";
import { useNavigate } from "react-router-dom";
import storePersist from "../../redux/storePersist";
import { getCardData } from "../../common/services/website-card.service";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from 'swiper/modules';

export default function Ventureview() {
  const dispatch = useAppDispatch();
  const [dbaasProgram, setDBaasProgram] = useState<any[]>([]);
  const venturesItems = useSelector(selectVenturesListItems);
  const image = require('../../assets/img/venture.jpg');
  const [searchTerm, setSearchTerm] = useState<string>("");
  const navigate = useNavigate()
  const [showPrograms, setShowPrograms] = useState(false);

  const handleEvents = async () => {
    await navigate('/events')
  }

  const handlePrograms = async () => {
    await navigate('/programs')
  }
  const handleCommunities = async () => {
    await navigate('/communities')
  }

  const dummyData = [{

    src: "../../assets/img/image 1.png",

  },
  ]

  useEffect(() => {
    dispatch(ventures.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/ventures/list`,
      entity: 'ventures',
      jsonData: {}
    }));
  }, [dispatch]);

  useEffect(() => {
    setDBaasProgram(venturesItems?.result?.items || []);
  }, [venturesItems]);

  const filteredVentures = dbaasProgram.filter((venture) => {
    const name = venture?.Name?.toLowerCase() || "";
    const city = venture?.City?.toLowerCase() || "";
    return name.includes(searchTerm.toLowerCase()) || city.includes(searchTerm.toLowerCase());
  });


  const VenturePageBanner: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONE_DIGIIT_VENTURE_PAGE_BANNER') : null;

  const venturePageIdeaHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONE_DIGIIT_VENTURE_PAGE_IDEA_HEADING') : null;
  const venturePageIdeaContent: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONE_DIGIIT_VENTURE_PAGE_IDEA_CONTENT') : null;

  return (
    <div className="min-h-screen bg-white px-4 py-8">

      <div className="w-full bg-white px-4 py-12">
        <div className="max-w-7xl mx-auto flex flex-col gap-6">
          {/* Text Section */}
          <div className="w-full md:w-3/5">
            <h1 className="text-4xl font-extrabold text-left text-black leading-tight mb-4">
              {VenturePageBanner && VenturePageBanner[0]?.title ? (
                (() => {
                  const titleWords = VenturePageBanner[0].title.split(' ');
                  const middle = Math.floor(titleWords.length / 2);
                  const firstHalf = titleWords.slice(0, middle).join(' ');
                  const secondHalf = titleWords.slice(middle).join(' ');
                  return (
                    <>
                      <span className="text-primary">{firstHalf} </span>
                      <span className="text-black">{secondHalf}</span>
                    </>
                  );
                })()
              ) : (
                <>
                  <span className="text-primary">Find the Right Program </span>
                  <span className="text-black">to Build and Scale Your Startup</span>
                </>
              )}
            </h1>

            <p className="text-left text-gray-700 max-w-xl text-base">
              {VenturePageBanner && VenturePageBanner[0]?.subTitle ? (
                (() => {
                  const words = VenturePageBanner[0].subTitle.split(' ');
                  const middle = Math.floor(words.length / 2);
                  const firstHalf = words.slice(0, middle).join(' ');
                  const secondHalf = words.slice(middle).join(' ');
                  return (
                    <>
                      <span className="text-primary font-semibold">{firstHalf} </span>
                      {secondHalf}
                    </>
                  );
                })()
              ) : (
                <>
                  <span className="text-primary font-semibold">
                    From inception to scale – we’ve got you covered.{" "}
                  </span>
                  ONEX has empowered startups to drive technological innovation, scale globally, and create lasting impact.
                </>
              )}
            </p>
          </div>

          {/* Image Row */}
          <div className="flex  md:flex-row  mt-8">
            <div className="w-screen overflow-hidden">
              <img
                src={
                  VenturePageBanner && VenturePageBanner[0]?.src
                    ? VenturePageBanner[0]?.src
                    : 'https://via.placeholder.com/1600x400'
                }
                alt="Venture Banner"
                className="w-screen h-[400px] object-cover object-center"
              />
            </div>
          </div>
        </div>
      </div>



      <div className="max-w-7xl mx-auto">


        <div className="min-h-screen bg-white mt-16 px-4 py-8">
          <div className="max-w-7xl mx-auto">

            {/* Section Header */}
            <h2 className="text-3xl font-bold mb-2">
              {venturePageIdeaHeading && venturePageIdeaHeading[0]?.title ? (
                (() => {
                  const titleWords = venturePageIdeaHeading[0].title.split(' ');
                  const middle = Math.floor(titleWords.length / 2);
                  const firstHalf = titleWords.slice(0, middle).join(' ');
                  const secondHalf = titleWords.slice(middle).join(' ');
                  return (
                    <>
                      <span className="text-primary">{firstHalf} </span>
                      <span className="text-black">{secondHalf}</span>
                    </>
                  );
                })()
              ) : (
                <>
                  <span className="text-primary">One Service Provider for </span>
                  <span className="text-black">Startups in India</span>
                </>
              )}
              {/* <span className="text-primary">Programs</span> for Every Stage of Your Startup Journey */}
            </h2>
            <p className="text-gray-600 mb-8">
              {venturePageIdeaHeading ? venturePageIdeaHeading[0]?.subTitle : null}
            </p>

            {/* Expandable Section */}
            <div
              className={`bg-primary text-white rounded-lg p-10 shadow-lg mb-10 overflow-hidden transition-all duration-500 ease-in-out ${showPrograms ? 'max-h-[500px]' : 'max-h-[200px]'
                }`}
            >
              <div className="flex justify-between items-start mb-4">
                <div>
                  <div className="flex items-center space-x-2 mb-2">
                    <div className="bg-secondary p-2 rounded-md">
                      <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                        <path d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20z" />
                      </svg>
                    </div>
                    <h3 className="text-xl font-semibold">{venturePageIdeaContent ? venturePageIdeaContent[0]?.title : null}</h3>
                  </div>
                  <p className="text-sm text-white/90 max-w-xl">
                    {venturePageIdeaContent ? venturePageIdeaContent[0]?.description : null}
                  </p>
                </div>

                <button
                  onClick={() => setShowPrograms(!showPrograms)}
                  className="bg-white text-secondary font-semibold px-4 py-2 rounded-md hover:bg-gray-200 transition"
                >
                  {venturePageIdeaContent ? venturePageIdeaContent[0]?.subTitle : null}
                </button>
              </div>

              {/* Expandable Content */}
              {showPrograms && (
                <div className="flex flex-wrap gap-4 mt-6">
                  <button onClick={handleEvents} className="bg-white text-secondary px-4 py-2 rounded-md font-medium hover:bg-gray-100 transition">
                    Events &gt;
                  </button>
                  <button onClick={handlePrograms} className="bg-white text-secondary px-4 py-2 rounded-md font-medium hover:bg-gray-100 transition">
                    Programs &gt;
                  </button>
                  <button onClick={handleCommunities} className="bg-white text-secondary px-4 py-2 rounded-md font-medium hover:bg-gray-100 transition">
                    Community &gt;
                  </button>
                </div>
              )}
            </div>

            <div className="mb-4 flex justify-between items-center">
              <input
                id="search"
                type="text"
                placeholder="Search ventures..."
                className="w-1/2 px-4 py-2 border rounded-lg"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <h2 className="text-center text-2xl md:text-3xl font-bold text-gray-800 mb-8">
              Ventures
            </h2>

            <Swiper
              modules={[Navigation]} // You can remove Navigation too if not used
              spaceBetween={0}
              breakpoints={{
                320: { slidesPerView: 1 },
                640: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 4 },
              }}
              className="w-full pt-10 bg-gray-100"
            >
              {filteredVentures.slice(0, 6).map((venture, index) => (
                <SwiperSlide key={index}>
                  <div className="flex flex-col items-center p-4">

                    {/* Name */}
                    <div className="font-semibold text-lg text-center text-black">
                      {venture?.Name}
                    </div>

                    {/* Image with City name overlay */}
                    <div className="relative w-60 h-60 overflow-hidden rounded-md shadow-md">
                      <img
                        className="w-full h-full object-cover"
                        src={venture?.CoverImageUrl || image}
                        alt={venture?.UserName || "Venture Image"}
                      />

                      {/* Overlay background angle */}
                      <div className="absolute bottom-0 left-0 w-full h-10 bg-secondary -skew-y-6 origin-bottom"></div>

                      {/* City text inside image */}
                      <div className="absolute bottom-2 left-0 w-full text-center text-white text-sm font-medium">
                        {venture?.City || <span className="invisible">City Name</span>}
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>


            <div className="flex justify-center pt-4">
              <button onClick={() => { navigate('/ventures') }} className="border rounded bg-gray-50 hover:bg-gray-100 border-gray-200 text-gray-800 p-2 text-md">Show all ventures</button>
            </div>
          </div>
        </div>



        {/* {filteredVentures.length === 0 ? (
          <div className="text-center text-gray-600 text-md">
            No available ventures to show.
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {filteredVentures.map((venture, index) => (
              <div
                key={venture?.Id || index}
                className="flex flex-col items-center border border-gray-200 rounded-xl bg-white shadow hover:shadow-lg transition-transform hover:scale-105 p-5"
              >
                <div className="w-24 h-24 rounded-full overflow-hidden border-4 border-gray-200 shadow">
                  <img
                    className="w-full h-full object-cover"
                    src={venture?.CoverImageUrl || image}
                    alt={venture?.UserName || "Venture Image"}
                  />
                </div>

                <div className="mt-4 text-center">
                  <div className="font-semibold text-base text-gray-900 break-words text-center leading-snug">
                    {venture?.Name}
                  </div>
                  <div className="text-gray-600 mt-1 text-sm">
                    {venture?.City}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )} */}
      </div>
    </div>
  );
}
